module.exports = __webpack_public_path__ + "img/banner-icon-1.58390284.webp";